// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section::-webkit-scrollbar-thumb, .section::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.section::-webkit-scrollbar-thumb {
  background-color: #A8AEB0;
}

.bold-text {
  font-weight: 700;
  color: black;
}

.section {
  overflow: auto;
}
.section .red-color {
  color: #E63200;
}
.section .green-color {
  color: #0DB4A7;
}
.section .blue-color {
  color: #00A9E0;
}
.section .shadowed {
  box-shadow: 0px 10px 20px rgba(136, 166, 211, 0.1);
}
.section .link-btn {
  margin: 0 auto 35px;
}

.container {
  padding: calc(var(--headerHeight) + 40px) 16px 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: normal;
  min-width: 288px;
}
.container .accordion {
  margin-top: auto;
}

.headings {
  margin-bottom: 18px;
}
.headings .description {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/MercuryoWidget/Styles/MainContent.scss","webpack://./src/assets/styles/color-variables.scss"],"names":[],"mappings":"AAEA;EACE,UAAA;EACA,WAAA;AACF;;AAME;EAEE,yBAAA;AAJJ;;AAOA;EACE,gBAAA;EACA,YAAA;AAJF;;AAMA;EACE,cAAA;AAHF;AAME;EACE,cCrBE;ADiBN;AAOE;EACE,cC3BI;ADsBR;AAQE;EACE,cChCQ;AD0BZ;AASE;EACE,kDAAA;AAPJ;AAWE;EACE,mBAAA;AATJ;;AAaA;EACE,gDAAA;EAEA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EAIA,gBAAA;AAdF;AAWE;EACE,gBAAA;AATJ;;AAaA;EACE,mBAAA;AAVF;AAWE;EACE,eAAA;AATJ","sourcesContent":["@import \"src/assets/styles/variables\";\n\n%scrollbarStyle{\n  width: 4px;\n  height: 4px;\n}\n\n%scrollbar{\n  &::-webkit-scrollbar {\n    @extend %scrollbarStyle;\n  }\n  &::-webkit-scrollbar-thumb {\n    @extend %scrollbarStyle;\n    background-color: #A8AEB0;\n  }\n}\n.bold-text{\n  font-weight: 700;\n  color: black;\n}\n.section {\n  overflow: auto;\n  @extend %scrollbar;\n\n  .red-color {\n    color: $red;\n  }\n\n  .green-color {\n    color: $green;\n  }\n\n  .blue-color {\n    color: $iris-blue;\n  }\n\n  .shadowed {\n    box-shadow: 0px 10px 20px rgba(136, 166, 211, 0.1);\n  }\n\n\n  .link-btn {\n    margin: 0 auto 35px;\n  }\n}\n\n.container{\n  padding: calc(var(--headerHeight) + 40px) 16px 0;\n  //height: calc(100% - var(--headerHeight));\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: normal;\n  .accordion{\n    margin-top: auto;\n  }\n  min-width: 288px\n}\n.headings{\n  margin-bottom: 18px;\n  .description{\n    margin-top: 8px;\n  }\n}\n","$blue: #1B2C74;\n$iris-blue: #00A9E0;\n$green: #0DB4A7;\n$orange: #FBB03B;\n$red: #E63200;\n$white: #FFF;\n$grey: #8994A3;\n$dark: #333;\n$black: #000;\n\n@function dm-color($color: $blue, $tone: 600) {\n  @if $tone == 600 {\n    @return $color;\n  }\n  @return map-get(\n                  map-get($color-variations, $color),\n                  $tone\n  );\n}\n\n$color-variations: (\n        $blue: (\n                400: #2C79E7,\n                600: $blue,\n        ),\n        $grey: (\n                50: #F2F4F7,\n                100: #E1E6EC,\n                200: #F2F4F6,\n                300: #F7F9FC,\n                400: #CAD5E4,\n                500: #F3F3FA,\n                600: $grey,\n        ),\n        $dark: (\n                500: #566170,\n                600: $dark,\n                900: $black,\n        ),\n        $green: (\n                500: #0DC3A7,\n                600: $green,\n        ),\n);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
